<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>lblEditRentalCar</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
            </a>
        </div>
      </div>
      <div *ngIf="editRentalCarForm">
        <form [formGroup]="editRentalCarForm" (ngSubmit)="EditRentalCarDetails()">
          <div class="scrollbar">
            <div class="card-content">
              <div class="card-body p-0">
                <div class="form-row">

                  <div class='col-6 af-form-group'>
                    <label translate>lblSelectDealer <span class="required">*</span></label>
                    <div class='lbl-info'>
                      <input id="typeahead-format" type="text" formControlName="dealerName" class="form-control mb-2"
                      placeholder="Search Dealer" [(ngModel)]="dealerSelected" name="searchDealer"
                      [resultFormatter]="formatter" (selectItem)="setDealer($event)" disabled />
                    </div>
                  </div>
                  
                  <div class="col-6 af-form-group">
                      <label for="template-edit-company" translate>lblMake<strong class="mlt6 required"> * </strong>
                      </label>
                      <div class='lbl-info'>
                        <ng-select placeholder="{{ 'lblSelectMake' | translate }}" formControlName="company" name="company"
                          [class.in-invalid]="cpf.company.invalid && cpf.company.touched" required
                          [ngClass]="{'is-invalid': cpf.company.invalid && cpf.company.touched}" (change)="onMakeSelected($event)">
                          <ng-template ng-header-tmp>
                            <span class="mbold w-66px">Code</span>
                            <span class="mbold" translate>lblMake</span>
                          </ng-template>
                          <ng-option *ngFor="let brand of brandList" [value]="brand.brandCode">
                            <span class="w-66px">{{brand.brandCode}}</span>
                            <span class="mx-2 hide-ng-dropdown-panel">-</span>
                            <span>{{brand.brandName}}</span>
                          </ng-option>
                        </ng-select>
                        <div *ngIf="cpf.company.invalid && (cpf.company.dirty || cpf.company.touched)" class="help-block text-danger">
                          <div *ngIf="cpf.company.errors.required">
                            <span translate>lblRequiredMake</span>
                          </div>
                        </div>
                      </div>
                    </div>
    
                    <div class="col-6 af-form-group">
                      <label for="template-edit-model" translate>lblModel<strong class="mlt6 required"> * </strong>
                      </label>
                      <div class='lbl-info'>
                        <ng-select placeholder="{{ 'lblSelectModel' | translate }}" name="model" formControlName="model"
                        [class.in-invalid]="cpf.model.invalid && cpf.model.touched" required [(ngModel)]="RentalCarInfo.model"
                        [ngClass]="{'is-invalid': cpf.model.invalid && cpf.model.touched}">
                        <ng-option *ngFor="let models of modelList" [value]="models.description">
                          {{models.description}}
                        </ng-option>
                      </ng-select>
                      <div *ngIf="cpf.model.invalid && (cpf.model.dirty || cpf.model.touched)" class="help-block text-danger">
                        <div *ngIf="cpf.model.errors.required">
                          <span translate>lblRequiredModel</span>
                        </div>
                      </div>
                      </div>
                    </div>
    
                    <div class="col-6 af-form-group">
                      <label for="template-edit-fuel" translate>lblFuelType<strong class="mlt6 required" *ngIf="keepExtraFieldsMandatory"> * </strong> </label>
                      <div class='lbl-info'>
                        <ng-select placeholder="{{ 'lblFuel' | translate }}" name="fuel" formControlName="fuel" required
                          [class.in-invalid]="cpf.fuel.invalid && cpf.fuel.touched" [required]="keepExtraFieldsMandatory"
                          [ngClass]="{'is-invalid': cpf.fuel.invalid && cpf.fuel.touched}" [(ngModel)]="selectedAttributes">
                        
                          <ng-option *ngFor="let Fuel of fuels" [value]="Fuel.id">
                            {{Fuel.fuelType}}
                          </ng-option>
                        </ng-select>
                        <div *ngIf="cpf.fuel.invalid && (cpf.fuel.dirty || cpf.fuel.touched)" class="help-block text-danger">
                          <div *ngIf="cpf.fuel.errors.required"><span translate>lblFuelRequired</span>
                          </div>
                        </div>
                      </div>
                    </div>

                  <div class="col-6 af-form-group">
                      <label for="template-edit-licensePlatNo" translate>lblRegNumber<strong class="mlt6 required" *ngIf="keepExtraFieldsMandatory"> * </strong>
                      </label>
                      <div class='lbl-info'>
    
                        <div class="input-group licplate">
                          <div class="input-group-prepend">
                            <div class="icn-flag" [ngClass]="licensePlateClass"></div>
                          </div>
                        
                          <input type="text" id="licensePlatNo" name="licensePlatNo" 
                          class="form-control" formControlName="licensePlatNo" pattern="^[a-zA-Z0-9_ ]*$"
                          maxlength="20" [required]="keepExtraFieldsMandatory"
                          [ngClass]="{'is-invalid': cpf.licensePlatNo.invalid && cpf.licensePlatNo.touched}">
                              <button class="add-button btn btn-primary  px-2-5 radius-lb-flat" type="button"
                                (click)="searchVehicle()" translate><em class="fa fa-search"></em></button>    
                        </div>
    
    
                        
                        <div *ngIf="cpf.licensePlatNo.invalid && (cpf.licensePlatNo.dirty || cpf.licensePlatNo.touched)"
                          class="help-block text-danger">
                          <div *ngIf="cpf.licensePlatNo.errors.required"><span translate>lblLicensePlateRequired</span></div>
                          <div *ngIf="cpf.licensePlatNo.errors.pattern"><em class="fa fa-exclamation-circle"
                              aria-hidden="true"></em><span translate>lblSpecialCharacterAndSpacesAreNotAllowed
                            </span></div>
                        </div>
                      </div>
                    </div>


                  <div class="col-6 af-form-group">
                    <label for="service" translate>lblColor</label>
                    <div class="lbl-info relative" >
                      <input class="form-control" type="text"  [value]="color" formControlName="color" autocomplete="off">
                    </div>
                  </div>

                  <div class="col-6 af-form-group">
                    <label for="service" translate>lblYear <span class="required" *ngIf="keepExtraFieldsMandatory">*</span></label>
                    <div class="lbl-info">
                      <input formControlName="year" class="form-control mb-2"
                        [ngClass]="{'is-invalid': cpf.year.invalid}">
                      <div *ngIf="cpf.year.invalid && (cpf.year.dirty || cpf.year.touched)"
                        class="help-block text-danger">
                        <span *ngIf="cpf.year.errors?.required" translate> lblYearRequired
                        </span>
                        <span *ngIf="cpf.year.errors?.min || cpf.year.errors?.max" translate>
                          lblYearValid </span>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 af-form-group">
                    <label for="service" translate>lblRegistrationDate <span class="required" *ngIf="keepExtraFieldsMandatory">*</span></label>
                    <div class="lbl-info">
                      <div class="input-group date">
                        <input class="form-control datePicker width100force" appAfDatepicker [required]="keepExtraFieldsMandatory" [dateTime]="false"
                          name="registrationDate" [(ngModel)]="registrationDate" [ngModelOptions]="{standalone: true}" [disableNextMonthDates]="true"
                          [startDate]="'1949/12/31'" id="txtboxStartDate" [readonly]="keepExtraFieldsMandatory" type="text" value="" [disabled]="keepExtraFieldsMandatory">
                        <em class="fas fa-calendar-alt fa-lg"></em>
                      </div>
                    </div>
                  </div>
                  
                  <div class="col-6 af-form-group">
                    <label for="service" translate>lblEngineNo <span class="required" *ngIf="keepExtraFieldsMandatory">*</span></label>
                    <div class="lbl-info">
                      <input formControlName="engineNo" class="form-control mb-2"
                        [ngClass]="{'is-invalid': cpf.engineNo.invalid}">
                      <div *ngIf="cpf.engineNo.invalid || (cpf.engineNo.touched && (cpf.engineNo.errors?.required))"
                        class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                          aria-hidden="true"></em>
                        lblEngineNoRequired
                      </div>
                    </div>
                  </div>
                  
                  <div class="col-6 af-form-group">
                    <label for="service" translate>lblVinNumber <span class="required" *ngIf="keepExtraFieldsMandatory">*</span></label>
                    <div class="lbl-info">
                      <input formControlName="chessisNo" class="form-control mb-2"
                        [ngClass]="{'is-invalid': cpf.chessisNo.invalid}" maxlength="25">
                      <div *ngIf="cpf.chessisNo.touched && (cpf.chessisNo.errors?.required)"
                        class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                          aria-hidden="true"></em>
                        lblChessisNoRequired
                      </div>
                    </div>
                  </div>
                  
                  
                  <div class="col-6 af-form-group">
                    <label for="service" translate>lblCharges <span class="required">*</span></label>
                    <div class="lbl-info">
                      <input formControlName="charges" class="form-control mb-2" required pattern="^[\d,.\s]{0,8}$"
                        (blur)="onBlur($event)"  (keyup)="checkLength($event)" [ngClass]="{'is-invalid': cpf.charges.invalid}"
                        [ngModel]="charges | toNumber | number:'1.2-2'">
                      <div *ngIf="cpf.charges.touched && (cpf.charges.errors?.required)"
                        class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                          aria-hidden="true"></em>
                        lblChargesRequired
                      </div>
                      <div *ngIf="isChargesLengthError"
                        class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                          aria-hidden="true"></em>
                        lblChargesUpto4digit
                      </div>
                      <div *ngIf="(cpf.charges.touched && (cpf.charges.errors?.pattern)) ||isValidRentalPrice"
                        class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                          aria-hidden="true"></em>
                        lblValidRentalPrice
                      </div>
                    </div>
                  </div>
                  
                  <div class="col-6 af-form-group">
                      <label>&nbsp;</label>
                    <div class="lbl-info">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="isActive" formControlName="isActive">
                        <label class="custom-control-label" for="isActive" translate>lblActive</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="p-3 bg-light pp-footer-top-brdr">
          <div class="row">
            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
              <button type="submit" class="btn btn-primary mr-sm-2 btn-lg" aria-label="Center Align" [disabled]="!editRentalCarForm.valid || isChargesLengthError|| isValidRentalPrice"
                translate>lblSaveChanges</button>
              <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate>lblCancel</a>
            </div>
          </div>
        </div>
        </form>
      </div>
    </div>
  </div>
</div>